import { View, Text, StyleSheet, Platform } from "react-native";
import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { Box, Image, Typography } from "components/ui";

interface IProductGallery {
	data: any;
	isConfigurator?: boolean;
	setActiveProductSelected?: any;
	isGridImage?: boolean;
}
const ProductGallery = (props: IProductGallery) => {
	if (Platform.OS !== "web") {
		return <Typography>Not supported in native app yet.</Typography>;
	}

	const { data, setActiveProductSelected } = props;

	const renderCustomThumbs = () => {
		const thumbList = data.imageCollection.map((image: any, key: number) => {
			return (
				<picture key={key} onClick={() => (setActiveProductSelected ? setActiveProductSelected(key) : "")}>
					<source data-srcset={process.env.EXPO_PUBLIC_ABCO_API_CDNURL + image + "?width=400&quality=75&format=webp"} type="image/jpg" />
					<img key={key} src={process.env.EXPO_PUBLIC_ABCO_API_CDNURL + image + "?width=400&quality=75&format=webp"} alt={image} height="70" />
				</picture>
			);
		});
		return thumbList;
	};
	return (
		<Carousel
			className="carousel_custom"
			showIndicators={false}
			showStatus={false}
			renderThumbs={renderCustomThumbs}
			interval={8000}
			renderArrowPrev={(onClickHandler, hasPrev, label) =>
				hasPrev && (
					<button
						type="button"
						onClick={onClickHandler}
						className="link link--arrowed"
						title={label}
						style={{ position: "absolute", left: 15, zIndex: 2, top: "calc(50% - 15px)", width: 50, height: 50, cursor: "pointer", border: "none", backgroundColor: "transparent" }}
					>
						<svg
							className="arrow-icon"
							xmlns="http://www.w3.org/2000/svg"
							style={{
								transform: "scale(-1,1)",
							}}
							width="50"
							height="50"
							viewBox="0 0 32 32"
						>
							<g fill="none" stroke="#2B6FBB" strokeWidth="1" strokeLinejoin="round" strokeMiterlimit="10">
								<circle className="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
								<path className="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
							</g>
						</svg>
					</button>
				)
			}
			renderArrowNext={(onClickHandler, hasNext, label) =>
				hasNext && (
					<button
						type="button"
						className="link link--arrowed"
						onClick={onClickHandler}
						title={label}
						style={{ position: "absolute", right: 15, zIndex: 2, top: "calc(50% - 15px)", width: 50, height: 50, cursor: "pointer", border: "none", backgroundColor: "transparent" }}
					>
						<svg className="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 32 32">
							<g fill="none" stroke="#2B6FBB" strokeWidth="1" strokeLinejoin="round" strokeMiterlimit="10">
								<circle className="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
								<path className="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
							</g>
						</svg>
					</button>
				)
			}
			autoPlay
			infiniteLoop
		>
			{data.imageCollection.map((image: any, key: number) => {
				return (
					<Box alignItems="center" justifyContent="center" key={key}>
						<Image key={key} aspectRatio={1.32 / 1} resizeMode="contain" borderRadius={20} width={400} source={process.env.EXPO_PUBLIC_ABCO_API_CDNURL + image + "?width=400&quality=75&format=webp"} alt="" />
					</Box>
				);
			})}
		</Carousel>
	);
};

export default ProductGallery;
